module.exports = __webpack_public_path__ + "img/178.6ced5242.jpg";